import { QUICK_FILTERS_CHANGE, QUICK_FILTERS_RESET } from './constants'

export default function () {
  const initialState = {
    quickFilters: [],
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case QUICK_FILTERS_CHANGE:
        return { ...state, quickFilters: action.payload.array }
      case QUICK_FILTERS_RESET:
        return { ...state, quickFilters: [] }
      default:
        return state
    }
  }
}
